type UnauthorizedHandler = () => void;

let currentHandler: UnauthorizedHandler | null = null;

// Bridge between the plain-function fetch layer and the React auth layer. The
// fetch helpers can't call useAuth().logout() directly, so AuthProvider registers
// a handler here and the helpers invoke it via notifyUnauthorized() on a 401.
export function registerUnauthorizedHandler(handler: UnauthorizedHandler) {
  currentHandler = handler;

  return () => {
    if (currentHandler === handler) {
      currentHandler = null;
    }
  };
}

export function notifyUnauthorized() {
  currentHandler?.();
}
